import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  BooleanInput,
  DateTimeInput,
  ReferenceInput,
  AutocompleteInput,
  required,
} from 'react-admin';

const promoTypes = [
  { id: 'percentage', name: 'Процент' },
  { id: 'fixed_amount', name: 'Фиксированная сумма' },
];

const PromoCodeCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="code" label="Код" validate={required()} />
      <SelectInput source="type" label="Тип" choices={promoTypes} validate={required()} />
      <NumberInput 
        source="value" 
        label="Значение" 
        validate={required()} 
        helperText="Для процента: 0-100, для суммы: в рублях"
      />
      
      <ReferenceInput 
        source="productId" 
        reference="products" 
        label="Продукт"
      >
        <AutocompleteInput 
          optionText="title" 
          validate={required()} 
          filterToQuery={(searchText: string) => ({ title: searchText })}
        />
      </ReferenceInput>
      
      <DateTimeInput 
        source="validFrom" 
        label="Действует с" 
        helperText="Оставьте пустым, чтобы промокод был активен сразу"
      />
      <DateTimeInput 
        source="validUntil" 
        label="Действует до" 
        helperText="Оставьте пустым для бессрочного действия"
      />
      
      <NumberInput 
        source="maxUsageCount" 
        label="Макс. количество использований" 
        helperText="Оставьте пустым для неограниченного использования"
      />
      
      <BooleanInput source="isActive" label="Активен" defaultValue={true} />
    </SimpleForm>
  </Create>
);

export default PromoCodeCreate;